import React from "react";
import styled from "styled-components";

import { sm } from "../../../AppTheme.styled";
import { IInput } from "./Input.interface";

const StyledInput = styled.input<IInput>`
  font-size: 16px;
  line-height: 24px;
  outline: none;
  width: 100%;
  padding: ${({ small }) => (small ? "6px" : "15px")}
    ${({ Icon }) => (Icon ? "43px" : "15px ")};
  border-radius: 10px;
  box-sizing: border-box;
  letter-spacing: 0.15px;
  color: ${({ error, theme }) =>
    error ? theme.palette.error : theme.palette.neutral1};
  background-color: transparent;
  border: 1px solid
    ${({ error, theme }) =>
      error ? theme.palette.error : theme.palette.neutral4};

  &::placeholder {
    text-transform: capitalize;
    color: ${({ theme }) => theme.palette.neutral3};
  }
  &:focus {
    box-shadow: 0 0 0 1px
      ${({ error, theme }) =>
        error ? theme.palette.error : theme.palette.primary};
    border-color: ${({ error, theme }) =>
      error ? theme.palette.error : theme.palette.primary};
  }
  &[disabled] {
    cursor: not-allowed;
    opacity: ${({ theme }) => theme.disabledOpacity};
  }

  ${sm} {
    width: 100%;
  }
`;

export const StyledInputWrap = styled.div`
  position: relative;

  & > svg {
    fill: ${({ theme }) => theme.palette.neutral3};
    width: 20px;
    position: absolute;
    left: 16px;
    top: 10px;
  }
`;

export default StyledInput;
